import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_tac _mt-4" }
const _hoisted_2 = { class: "_fw-b" }
const _hoisted_3 = { class: "_fw-b" }
const _hoisted_4 = { class: "_mt-1" }
const _hoisted_5 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createBlock(_component_box, { class: "gfu-box--huge" }, {
    default: _withCtx(() => [
      _cache[6] || (_cache[6] = _createElementVNode("h2", {
        class: "gfu-heading gfu-box__title gfu-hd gfu-hd--h1 gfu-heading--top-divider-center",
        "data-qa": "page-title"
      }, "Unsubscribe confirmation", -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "_mb-1" }, "You will be unsubscribed from", -1 /* CACHED */)),
          _createElementVNode("span", _hoisted_2, _toDisplayString($options.notificationTopicDisplayText), 1 /* TEXT */),
          _cache[4] || (_cache[4] = _createTextVNode(" email notifications ", -1 /* CACHED */)),
          ($props.contextName)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[0] || (_cache[0] = _createTextVNode(" about ", -1 /* CACHED */)),
                _createElementVNode("span", _hoisted_3, _toDisplayString($props.contextName), 1 /* TEXT */)
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createTextVNode(" on " + _toDisplayString($options.platformName) + ". ", 1 /* TEXT */),
          _createElementVNode("div", _hoisted_4, [
            _cache[1] || (_cache[1] = _createTextVNode(" Visit your ", -1 /* CACHED */)),
            _createElementVNode("a", {
              href: $options.subscriptionManagementUrl,
              class: "gfu-link gfu-link--accent",
              "data-qa": "communication-preferences-link"
            }, "communication preferences", 8 /* PROPS */, _hoisted_5),
            _cache[2] || (_cache[2] = _createTextVNode(" for more notification settings. ", -1 /* CACHED */))
          ])
        ]),
        _createVNode(_component_base_button, {
          theme: "accent",
          class: "_mt-4",
          onClick: _withModifiers($options.confirmUnsubscribe, ["prevent"]),
          "data-qa": "unsubscribe-button"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode(" Unsubscribe ", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"])
      ]),
      _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
    ]),
    _: 1 /* STABLE */
  }))
}